import { deserialize, deserializeArray, serialize } from 'class-transformer';
import { Guid } from 'guid-typescript';
import { AvailableUpdateStatus } from './AvailableUpdateStatus';
import { EStopStatus } from './EStopStatus';
import { MachineSoftwareUpdateState } from './MachineSoftwareUpdateState';
import { MachineSoftwareUpdateStepType } from './MachineSoftwareUpdateStepType';

export class MachineSWUpdateData {
  account_id: string;
  machine_id: string;
  machine_name: string;
  current_machine_version: string;
  available_machine_version: string;
  available_update_status: AvailableUpdateStatus;
  estop_status: EStopStatus;
  software_update_state: MachineSoftwareUpdateState;
  sent_utc: Date;
  total_update_steps: number;
  update_steps_completed: number;
  current_update_step_type: MachineSoftwareUpdateStepType;

  constructor() {
    this.account_id = Guid.EMPTY.toString();
    this.machine_id = Guid.EMPTY.toString();
    this.machine_name = '';
    this.current_machine_version = '';
    this.available_machine_version = '';
    this.available_update_status = AvailableUpdateStatus.UNKNOWN;
    this.estop_status = EStopStatus.UNKNOWN;
    this.software_update_state = MachineSoftwareUpdateState.UNKNOWN;
    this.sent_utc = new Date();
    this.total_update_steps = 0;
    this.update_steps_completed = 0;
    this.current_update_step_type = MachineSoftwareUpdateStepType.UNKNOWN;
  }

  static toModel(json: string): MachineSWUpdateData {
    const model = deserialize(MachineSWUpdateData, json);
    return model;
  }

  static toModelCollection(json: string): MachineSWUpdateData[] {
    const models = deserializeArray(MachineSWUpdateData, json);
    return models;
  }

  fromModelToJson(): string {
    const jsObj = serialize(this);
    return jsObj;
  }
}
